























































































































































































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import PanelUploader from '@/modules/media/components/shared/PanelUploader.vue'
import SimpleTable from '@/modules/shared/components/shared/simple-table/SimpleTable.vue'
import SimpleTd from '@/modules/shared/components/shared/simple-table/SimpleTd.vue'
import RemovableBadge from '@/modules/shared/components/shared/badge/RemovableBadge.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'

@Component({
  components: {
    BaseTooltip,
    BaseButton,
    BaseInput,
    PanelUploader,
    SimpleTd,
    SimpleTable,
    RemovableBadge,
    Heading,
    Modal
  }
})
export default class ContentItemContentModal extends Vue {

  @Prop({ default: '' }) readonly label!: string
  @PropSync('displayModal') modal !: boolean
  content = {
    data: {
      rules: {
        requires_permission_note: ''
      }
    }
  }
  model = {
    title: 'title',
    content: 'content',
    word_count: 4,
    attachments: [],
    description: 'description',
    lead: 'lead',
    publication_at: ''
  }
  contentItem = {
    keywords: ['کلمه اول', 'دوم', 'سومین کلمه ']
  }
  wordFile = null
  loading = false
  setDate = null
  disablePast = []
  date = null
  showAcceptModal = false

  uploadWord() {
    return false
  }

  get showUploader() {
    return true
  }
}
